import http from "../../http-commonv2";

const getPermissions = () => {
  return http.get(`/api/v2/permissions/me`);
};

const realtimeStatus = (data) => {
  return http.post(`/api/v2/realtime/status`, data);
};
const RealtimeService = {
  getPermissions,
  realtimeStatus,
};

export default RealtimeService;
